import * as types from './mutation-types'

const mutations = {
  [types.SET_DETAILSNAME](state,detailTitle){
    state.detailTitle = detailTitle
  },
  [types.SET_MOBLIE](state,moblie){
    state.moblie = moblie
  },
  [types.SET_SEARCHTEXT](state,searchText){
    state.searchText = searchText
  },
  [types.SET_CLICKCID](state,clickCid){
    state.clickCid = clickCid
  }
}

export default mutations
